import { formatCurrency } from "../../../../shared/utils/formatCurrency";

const METODO_LABEL = {
  TRANSFERENCIA: "Transferencia",
  EFECTIVO: "Efectivo",
  CHEQUE: "Cheque",
};

function fmtDate(iso) {
  if (!iso || iso.length < 10) return iso ?? "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

function PillBtn({ icon, label, color, hoverBg, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "4px 10px",
        background: "transparent",
        border: `1px solid ${color}33`,
        borderRadius: 20,
        color,
        fontSize: "0.76rem",
        fontWeight: 600,
        cursor: "pointer",
        transition: "background 0.15s, border-color 0.15s",
        whiteSpace: "nowrap",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.background = hoverBg;
        e.currentTarget.style.borderColor = color;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.borderColor = `${color}33`;
      }}
    >
      <i className={`fa-solid ${icon}`} style={{ fontSize: "0.7rem" }} />
      {label}
    </button>
  );
}

export default function ReceiptRow({
  receipt,
  onEdit,
  onDelete,
  onEmail,
  selected = false,
  onToggleSelect,
}) {
  const id = receipt.id;

  return (
    <tr style={{ background: selected ? "rgba(249,115,22,0.06)" : undefined }}>
      {/* Checkbox */}
      <td
        style={{ width: 36, paddingRight: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect?.(id, receipt)}
          style={{ cursor: "pointer", accentColor: "#f97316" }}
        />
      </td>

      <td style={{ fontWeight: 600, color: "#f9fafb" }}>
        {receipt.numero_recibo}
      </td>
      <td>
        {receipt.es_deposito_sin_identificar && !receipt.filial
          ? <span style={{ background:'rgba(249,115,22,0.15)', border:'1px solid rgba(249,115,22,0.4)',
              borderRadius:12, padding:'2px 8px', color:'#f97316', fontSize:'0.72rem', fontWeight:700 }}>
              Sin identificar
            </span>
          : (receipt.filial?.idFilial ?? "—")}
      </td>
      <td className="text-end">₡{formatCurrency(receipt.monto)}</td>
      <td>{fmtDate(receipt.fecha_pago)}</td>
      <td>{METODO_LABEL[receipt.metodo_pago] ?? receipt.metodo_pago}</td>
      <td>{receipt.cuenta_bancaria?.banco ?? "—"}</td>

      {/* Acciones */}
      <td className="text-center">
        <div style={{ display: "flex", gap: 5, justifyContent: "center" }}>
          <PillBtn
            icon="fa-pencil"
            label="Editar"
            color="#f97316"
            hoverBg="rgba(249,115,22,0.15)"
            onClick={() => onEdit?.(receipt)}
          />
          <PillBtn
            icon="fa-envelope"
            label="Correo"
            color="#60a5fa"
            hoverBg="rgba(96,165,250,0.15)"
            onClick={() => onEmail?.(receipt)}
          />
          <PillBtn
            icon={receipt.es_deposito_sin_identificar ? 'fa-rotate-left' : 'fa-trash'}
            label={receipt.es_deposito_sin_identificar ? 'Revertir' : 'Eliminar'}
            color="#f87171"
            hoverBg="rgba(248,113,113,0.15)"
            onClick={() => onDelete?.(receipt)}
          />
        </div>
      </td>
    </tr>
  );
}
